import { jsx, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Table } from '../../Table/Table.es.js';
import { AdvancedTableColumnHeader } from './AdvancedTableColumnHeader.es.js';

const AdvancedTableHead = ({ showHeader, sticky, getHeaderGroups })=>{
    return jsx(Fragment, {
        children: showHeader && jsx(Table.Head, {
            className: classNames('cb-advanced-table-head', {
                'is-sticky': sticky
            }),
            "data-testid": "header",
            children: getHeaderGroups().map((headerGroup)=>jsx(Table.Head.Row, {
                    children: headerGroup.headers.map((header)=>jsx(AdvancedTableColumnHeader, {
                            header: header
                        }, header.id))
                }, headerGroup.id))
        })
    });
};

export { AdvancedTableHead };
//# sourceMappingURL=AdvancedTableHead.es.js.map
